export default __webpack_public_path__ + "static/media/dots.1e305f98.png";